import { isInvalidAddress, isSsnError } from './formhelper.service'
import Errors from '@feathersjs/errors'

export class UserExistsError extends Error {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const extractMessageFromServiceError = (error: any): string => {
  if (typeof error === 'string') {
    return error
  }
  if (error && error.error) {
    return error.error
  }
  if (error.message) {
    return error.message
  }
  return `${error}`
}

export const extractMessageFromError = (error: Error): string => {
  if (typeof error === 'string') {
    return error
  }
  if (error.message) {
    return error.message
  }
  return `${error}`
}

export enum API_ERROR_CODES {
  NotAuthenticated = 401,
  ServerError = 500
}

export const isLoginError = (msg: string): boolean => {
  return (
    msg === 'User does not exist.' || msg === 'Incorrect username or password.'
  )
}

export const isExpiredTokenError = (msg: string): boolean => {
  return msg === 'The incoming token has expired' || msg === 'Unauthorized'
}

export const isApplicationError = (msg: string): boolean => {
  return isInvalidAddress(msg) || isSsnError(msg)
}

export class CreditApplicationError extends Errors.BadRequest {}
